export default "/images/9d802d86c5336d0ead48fc393cbb607a.avif";